import { loadEnv } from '@bedrockio/pages/utils';

export const { APP_URL } = loadEnv();
